import React from 'react';
import imageFooter from '../assets/img/backg_casas.svg';
import logoGrey from "../assets/img/Logo-grey.png"
import logoMin from "../assets/img/Logo-Ministerio-Economia.png"
import logoDig from "../assets/img/Logo-Digitaliza-Pyme.png"
import logoSem from "../assets/img/Logo-Semana-Pyme.png"

// <div class="d-flex justify-content-center mb-3">
//   <div class="p-2 bd-highlight"><img alt="Ministerio de Economía, Fomento y Turismo" className="img-fluid" src={logoMin} /></div>
//   <div class="p-2 bd-highlight"><img alt="Digitaliza tu Pyme" className="img-fluid" src={logoDig} /></div>
//   <div class="p-2 bd-highlight"><img alt= "Semana de la Pyme" className="img-fluid" src={logoSem} /></div>
// </div>

import '../assets/css/Footer.scss';

const Footer = () => (
  <footer>

    <img
      alt="Compra Pyme"
      className="img-fluid"
      src={imageFooter}
      style={{ width: '100%' }}
      />

    <div className="d-flex justify-content-center">
      <img alt="Compra Pyme" className="img-fluid" src={logoGrey} />
    </div>

    <div className="d-flex justify-content-center">
      <div className="col-auto " style={{ marginTop:'40px', marginBottom:'30px' }}>
        <h4>Una iniciativa de</h4>
      </div>
    </div>

    <div className="row" style={{"maxWidth":"1000px","margin":"0px auto"}}>
      <div className="col-4 rigth-footer-elements">
        <img alt="Ministerio de Economía, Fomento y Turismo" className="img-footer" src={logoMin} />
      </div>
      <div className="col-4 center-footer-elements">
        <img alt="Digitaliza tu Pyme" className="img-footer" style={{width: "200px", maxWidth: "200px"}} src={logoDig} />
      </div>
      <div className="col-4 left-footer-elements">
        <img alt= "Semana de la Pyme" className="img-footer" src={logoSem} />
      </div>
    </div>
  </footer>
);

export default Footer;
